'use strict';

angular.module('AcaApp').factory('CorrectionService',
  [
    'CorrectionResource',
    function(CorrectionResource){
      return{
        getCorrectionRecords: function(xmitrun){
          var rpcConfig = {method: 'GetCorrectionRecords', params: [xmitrun]};
          return CorrectionResource.executeRpc(rpcConfig).$promise;
        },
        getFamilyInformationToCorrect: function(subscriber){
          var rpcConfig = {method: 'GetFamilyInformationToCorrect', params: [subscriber]};
          return CorrectionResource.executeRpc(rpcConfig).$promise;
        },
        markAsReady: function(subscriber){
          var rpcConfig = {method: 'MarkAsReady', params: [subscriber]};
          return CorrectionResource.executeRpc(rpcConfig).$promise;
        },
        setReviewStatusOnReport: function(xmitrun, value){
          var rpcConfig = {method: 'SetReviewStatusOnReport', params: [xmitrun, value]};
          return CorrectionResource.executeRpc(rpcConfig).$promise;
        }
      };
    }
  ]);